<app-edtell-front-facing-dialog [config]="frontFacingDialogConfig">
    <div class="row mt-2">
        <div class="col-12">
            {{message}}
        </div>
    </div>
</app-edtell-front-facing-dialog>